import React from 'react'
import { Imgix, Form } from '@elements'
import { useGravityForms } from '@hooks'

export const CtaBillboardWithForm = ({
  billboardContent,
  billboardContentBackgroundColor,
  billboardFormId,
  billboardHeadline,
  billboardImage,
}) => {
  const form = useGravityForms(billboardFormId)
  const bgColor = `bg-brand-${billboardContentBackgroundColor}`
  const textColor =
    billboardContentBackgroundColor === `red` ? `text-white` : `text-gray-400`

  return (
    <section className="">
      <div className="flex flex-wrap">
        <div className="relative w-full lg:w-5/12">
          {billboardImage && (
            <Imgix
              src={billboardImage.mediaItemUrl}
              alt={billboardImage.altText}
              className="absolute inset-0 object-cover w-full h-full"
            />
          )}
        </div>
        <div
          className={`w-full p-10 lg:w-7/12 sm:py-16 xl:flex xl:items-center ${bgColor} ${textColor}`}
        >
          <div className="max-w-md mx-auto md:max-w-xl xl:max-w-2xl xl:ml-10">
            <h1 className="font-sans text-3xl font-bold tracking-wider uppercase md:text-4xl">
              {billboardHeadline}
            </h1>
            <div
              dangerouslySetInnerHTML={{ __html: billboardContent }}
              className={`prose prose-2xl ${textColor}`}
            ></div>
            <div className="w-full max-w-md mt-6 font-sans font-bold md:max-w-xl xl:max-w-2xl sm:mt-8">
              <Form
                form={form}
                submitButton={
                  <div className="mt-8">
                    <button
                      type="submit"
                      className="inline-block px-10 pt-1 mr-4 font-sans text-2xl font-bold text-gray-400 no-underline uppercase transition duration-200 bg-white border-6 border-brand-yellow hover:bg-brand-yellow"
                    >
                      Submit
                    </button>
                  </div>
                }
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  )
}
